export const metrika =(type:string, value:string)=>{
    // @ts-ignore
    window.ym(94193685,type,value)
}